import { render } from "./DarkToggle.vue?vue&type=template&id=b3b45588&scoped=true&ts=true"
import script from "./DarkToggle.vue?vue&type=script&lang=ts"
export * from "./DarkToggle.vue?vue&type=script&lang=ts"

import "./DarkToggle.vue?vue&type=style&index=0&id=b3b45588&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b45588"]])

export default __exports__